import { Switch } from '@mantine/core';
import IconVolume from '@tabler/icons-react/dist/esm/icons/IconVolume.mjs';
import IconVolumeOff from '@tabler/icons-react/dist/esm/icons/IconVolumeOff.mjs';
import { useCookie } from '@/shared/lib/hooks/use-cookie';

export const NotificationSoundToggle = () => {
  const [cookie, setCookie] = useCookie<boolean>('volume-enabled', null, true);

  const handleMuted = (val: boolean) => {
    setCookie(val);
  };

  return (
    <Switch
      size='sm'
      onLabel={<IconVolume size={14} />}
      offLabel={<IconVolumeOff size={14} />}
      classNames={{
        thumb: 'cursor-pointer',
      }}
      checked={cookie}
      onChange={({ currentTarget: { checked } }) => handleMuted(checked)}
    />
  );
};